module.exports = __webpack_public_path__ + "img/partner5.5224fbc7.png";